<template>
    <div class="rounded-lgr p-5 border flex flex-col gap-2.5 bg-white">
        <div class="flex flex-col gap-4">
            <slot name="icon"></slot>
            <div class="flex flex-col">
                <p class="nadia-chat-bold text-ink">{{ title }}</p>
                <p class="body text-ink-muted">{{ body }}</p>
            </div>
        </div>
        <HorizontalDivider class="mb-0 mt-auto" />
        <BaseButton theme="tertiary" :disabled="isStartingChat" class="px-0 self-start" @click="onClick">
            {{ isStartingChat ? "Starting chat..." : "Dive Deeper" }}
        </BaseButton>
        <p v-if="chatError" role="alert" class="details text-button-danger">{{ chatError }}</p>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import HorizontalDivider from "~vue/components/HorizontalDivider.vue";
import { useStartPerspectiveTopicChat } from "~vue/composables/useStartPerspectiveTopicChat";
import type { PerspectiveTopicCategory } from "~vue/pages/perspectiveTypes";

type PerspectiveCardProps = {
    title: string;
    body: string;
    letters: string;
    category: PerspectiveTopicCategory;
    index: number;
};

const props = defineProps<PerspectiveCardProps>();

const { isStartingChat, chatError, handleStartChat } = useStartPerspectiveTopicChat(props.category);

const onClick = () => handleStartChat(props.letters, props.index);
</script>
